import React from 'react'

export const ManageTemplateUserChannel = () => {
  return (
    <div>ManageTemplateUserChannel</div>
  )
}
